import SFullPage from './style.module.scss';
import FadeIn from '../../commonComponents/fadeIn';
import { src } from '../../../utils/common';
import { useRef, useEffect } from 'react';
import throttle from 'lodash/throttle';
import { useUserAgentInfo } from '../../../context/user-agent';
import { ButtonGroup } from '../../commonComponents/fullPageBanner';
import { useWebPResourceCompatibleFn } from '../../../hooks/useWebPResource';
import StreamLakeVideo from '@/components/StreamLakeVideo';
import { WebPNextImage as Image, WebPNativeImage } from '../../WebPImage';
import usePolyfillVideo from '@/hooks/usePolyfillVideo';
import classnames from 'classnames';

// PC端文字的位置
declare type Position = 'left' | 'right';
// 移动端 文字对齐方式
declare type MobilePosition = 'left' | 'center';
// 资源类型
declare type MediaType = 'video' | 'image';

const FullPageVideoSection = ({
  data,
  position = 'left',
  mobilePosition = 'center',
  color = '#fff',
  background = '#fff',
  scale = 1.2,
  buttonConfig,
  type = 'video',
}: {
  data: any;
  position?: Position;
  mobilePosition?: MobilePosition;
  color?: string;
  background?: string;
  scale?: number;
  type?: MediaType;
  buttonConfig?: { buttonText: string; linkText: string };
}) => {
  const ref = useRef(null);
  const { isMobile } = useUserAgentInfo();
  const webPResourceHandleFn = useWebPResourceCompatibleFn();
  const shouldVideoPolyfill = usePolyfillVideo();

  useEffect(() => {
    type === 'video' && ref.current && ref.current.play();
  }, []);

  const DescContent = () => {
    return (
      <FadeIn>
        <div className={SFullPage['content']} style={{ textAlign: position }}>
          <div className={SFullPage['title']}>
            {isMobile
              ? data.title1
              : data.title1.slice(0, data.title1.length - 1)}
          </div>
          {data.title2 && (
            <div className={SFullPage['title']}>{data.title2}</div>
          )}
          {/* FadeIn 会覆盖子元素的opacity属性 */}
          <div style={{ opacity: '0.6' }}>
            <FadeIn delay={500}>
              <div className={SFullPage['desc']}>{data.desc}</div>
            </FadeIn>
          </div>
        </div>
      </FadeIn>
    );
  };

  const MediaContent = ({ left }: { left?: boolean }) => {
    return (
      <>
        <FadeIn>
          <div
            className={classnames({
              [SFullPage['media']]: true,
              [SFullPage['media-left']]: !isMobile && left,
              [SFullPage['media-right']]: !isMobile && !left,
            })}
          >
            {type === 'video' ? (
              <StreamLakeVideo
                ref={ref}
                className={SFullPage['video-example']}
                src={src(data.videoUrl)}
                id="solution-icon"
                loop
                muted
                preload="auto"
                webkit-playsinline="true"
                playsInline
                x5-playsinline="true"
                playInNewWindow={shouldVideoPolyfill}
                placeholderImg={webPResourceHandleFn(src(data.placeholderImg))}
              />
            ) : (
              <div ref={ref} className={SFullPage['image-example']}>
                <Image
                  src={data.picUrl}
                  width={602}
                  height={346}
                  alt="sound matrix示例图片"
                />
              </div>
            )}
          </div>
        </FadeIn>
      </>
    );
  };

  const ContentMobile = () => {
    return (
      <FadeIn>
        <div className={SFullPage['content']} style={{ textAlign: position }}>
          <div className={SFullPage['title']}>
            {data.title1}
            {data.title2}
          </div>
          {/* FadeIn 会覆盖子元素的opacity属性 */}
          <MediaContent />
          <div style={{ opacity: '0.6' }}>
            <FadeIn delay={500}>
              <div className={SFullPage['desc']}>{data.desc}</div>
            </FadeIn>
          </div>
        </div>
      </FadeIn>
    );
  };

  return (
    <>
      <div
        className={`${SFullPage['section']} ${
          SFullPage[isMobile ? mobilePosition : position]
        }`}
        style={{ color, background }}
      >
        {isMobile ? (
          <ContentMobile />
        ) : position === 'left' || isMobile ? (
          <>
            <DescContent />
            <MediaContent left={false} />
          </>
        ) : (
          <>
            <MediaContent left={true} />
            <DescContent />
          </>
        )}
      </div>
      {buttonConfig && isMobile && <ButtonGroup data={buttonConfig} />}
    </>
  );
};

export default FullPageVideoSection;
